/**
 * Airport: DiscountedPrice × timelineFactor × unit × (BoughtSeconds / 10)
 *
 *   timelineFactor = timeline >= 10 ? timeline / 10 : timeline
 *   slotFactor     = BoughtSeconds / 10  (10s is the global timeslot pricing unit)
 *
 * Per-screen is intentionally not part of the formula.
 */
import { slotTenFactor, airportTimelineFactor } from './multipliers';

export function calculateAirportTotal(variant, selection) {
  const discountedPrice = Number(variant?.DiscountedPrice) || 0;
  const units = Number(selection?.unitsToBebought) || 1;
  const timelineFactor = airportTimelineFactor(selection?.timelineToBought);
  const slot = slotTenFactor(selection?.BoughtSeconds);
  return discountedPrice * timelineFactor * units * slot;
}
